import { TranslateResult } from "vue-i18n";
import { Location } from "vue-router";

export enum CreatorsTabsEnum {
  ALL = "ALL",
  ONLINE = "ONLINE",
  LIVE = "LIVE",
}

export type CreatorsListTab = {
  value: CreatorsTabsEnum;
  name: TranslateResult;
  to: Required<Location>["name"];
};
